import { Channel } from 'lib-shared-types-channels';

import { isEmpty, isInsufficientText } from './generic';

const isDisabled = (
  text: string,
  status: string | undefined,
  channel: Channel | undefined,
  hasStyleGuideForChannel: boolean,
): boolean => {
  return (
    !channel ||
    !hasStyleGuideForChannel ||
    isEmpty(text) ||
    isInsufficientText(text) ||
    status === 'pending'
  );
};

const tooltipContent = (
  text: string,
  status: string | undefined,
  channel: Channel | undefined,
  hasStyleGuideForChannel: boolean,
): string => {
  if (!channel) {
    return 'Unknown channel';
  }
  if (!hasStyleGuideForChannel) {
    return 'No style guide for this channel';
  }
  if (isEmpty(text)) {
    return 'No text to match to style guide';
  }
  if (isInsufficientText(text)) {
    return 'Not enough text to match to style guide';
  }
  if (status === 'pending') {
    return 'Matching to style guide...';
  }
  return 'Match to style guide';
};

export const matchToStyleGuideUtils = {
  getStatus(options: {
    text: string;
    status?: string;
    channel?: Channel;
    hasStyleGuideForChannel?: boolean;
  }): {
    isDisabled: boolean;
    tooltipContent: string;
    isInsufficientText: boolean;
  } {
    return {
      isDisabled: isDisabled(
        options.text,
        options.status,
        options.channel,
        !!options.hasStyleGuideForChannel,
      ),
      tooltipContent: tooltipContent(
        options.text,
        options.status,
        options.channel,
        !!options.hasStyleGuideForChannel,
      ),
      isInsufficientText: isInsufficientText(options.text),
    };
  },
};
